/**
 * Fixes two Zipify Cart Drawer + Bold Product Options conflicts:
 *
 * 1) Premature validation: Zipify validates Bold options on any click inside
 *    the add-to-cart form, so embroidery clicks show "This option is required"
 *    and scroll. Only validate on real Add to Cart.
 *
 * 2) Double add / flash-remove: Zipify's click listener is async (capture).
 *    While it awaits Bold validation, the event still reaches Bold's cloned
 *    ATC button / theme product-form, which also submits. Two adds race;
 *    Zipify then refreshes the drawer and the item can appear then vanish.
 *    After Zipify is listening, stop the event from reaching Bold/theme.
 */
(function () {
	var VALIDATE_PATCH_FLAG = '__boldOptionsValidatePatched';
	var DOUBLE_ADD_PATCH_FLAG = '__zipifyBoldDoubleAddPatched';
	var MAX_ATTEMPTS = 40;
	var INTERVAL_MS = 250;
	var lastEvent = null;

	function trackEvent(event) {
		lastEvent = event;
	}

	function isAddToCartInteraction(event) {
		if (!event || !event.target || !event.target.closest) return false;
		if (event.type === 'submit') return true;

		return !!(
			event.target.closest('[name="add"]') ||
			event.target.closest('.product-form__submit') ||
			event.target.closest('button[type="submit"]')
		);
	}

	function isBoldOptionsInteraction(event) {
		if (!event || !event.target || !event.target.closest) return false;
		return !!event.target.closest('.bold_options');
	}

	function hasBoldOptions() {
		return !!document.querySelector('.bold_options_loaded, .bold_options .bold_option');
	}

	function patchSCPO() {
		var cart = window.Zipify && window.Zipify.Cart;
		var scpo = cart && cart.integrations && cart.integrations.SCProductOptions;

		if (!scpo || scpo[VALIDATE_PATCH_FLAG] || typeof scpo.validateSCPO !== 'function') {
			return false;
		}

		var originalValidateSCPO = scpo.validateSCPO.bind(scpo);

		scpo.validateSCPO = function (form) {
			if (isBoldOptionsInteraction(lastEvent) && !isAddToCartInteraction(lastEvent)) {
				return Promise.resolve(true);
			}
			return originalValidateSCPO(form);
		};

		scpo[VALIDATE_PATCH_FLAG] = true;
		return true;
	}

	function patchDoubleAdd() {
		var cart = window.Zipify && window.Zipify.Cart;
		if (!cart || !cart.instance || window[DOUBLE_ADD_PATCH_FLAG]) return false;

		// Registered after Zipify's capture listener so Zipify still runs first,
		// then we block Bold's clone / theme submit handlers on the same click.
		document.addEventListener(
			'click',
			function (event) {
				if (!isAddToCartInteraction(event)) return;
				if (!hasBoldOptions()) return;
				if (!(window.Zipify && window.Zipify.Cart && window.Zipify.Cart.instance)) return;

				event.preventDefault();
				event.stopImmediatePropagation();
			},
			true
		);

		window[DOUBLE_ADD_PATCH_FLAG] = true;
		return true;
	}

	function tryPatch() {
		var scpoReady = patchSCPO();
		var doubleAddReady = patchDoubleAdd();
		return scpoReady && doubleAddReady;
	}

	function start() {
		document.addEventListener('click', trackEvent, true);
		document.addEventListener('keydown', trackEvent, true);
		document.addEventListener('submit', trackEvent, true);

		if (tryPatch()) return;

		var attempts = 0;
		var timer = setInterval(function () {
			attempts += 1;
			if (tryPatch() || attempts >= MAX_ATTEMPTS) {
				clearInterval(timer);
			}
		}, INTERVAL_MS);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start);
	} else {
		start();
	}
})();
